export const PROGRAM_CLOSE_DATE = new Date("2026-08-10T12:00:00+08:00");
